export const AI_TOOLS = [{
  id: 'cut_out',
  title: 'ai_cutout',
  description: 'remove_background_quickly',
  icon: 'cutOut',
  tipIcons: ['pictureV2Bold'],
  route: '/--roboneo/ai-cutout',
}, {
  id: 'remove',
  title: 'ai_removal',
  description: 'intelligent_elimination_of_debris',
  icon: 'magicElimination',
  badgeText: 'Hot',
  tipIcons: ['pictureV2Bold'],
  route: '/--roboneo/ai-eraser',
}, {
  id: 'remove_aimark',
  title: 'ai_watermark_removal',
  description: 'naturally_removes_watermarks_and_debris',
  icon: 'eraser',
  badgeText: 'Hot',
  tipIcons: ['pictureV2Bold', 'videoV4Bold'],
  route: '/--roboneo/ai-watermark',
}, {
  id: 'change_to_hd',
  title: 'image_quality_repair',
  description: 'improve_clarity_and_detail',
  icon: 'hdRectangle',
  tipIcons: ['pictureV2Bold', 'videoV4Bold'],
  route: '/--roboneo/ai-enhance',
},
];
